import QueryParameterHelper from '@/ui-kit/helpers/QueryParameterHelper';
import routes from '@/constants/routes';
import { QueryParams } from '@/constants/QueryParams';
import ListingMixin from './listing';
import BuildingTypeMapper
  from '@/components/features/comparables/shared/mappers/BuildingTypeMapper';

const NavigationLinksMixin = {
  mixins: [ListingMixin],
  computed: {
    commonComparableQueries() {
      return {
        [QueryParams.Parking]: this.listing.totalParking || 0,
        [QueryParams.Style]: this.listing.style,
        [QueryParams.MinYearBuilt]: this.listing.yearBuilt,
        [QueryParams.Beds]: this.listing.beds,
        [QueryParams.Baths]: this.listing.fullBaths,
        [QueryParams.MinFinishedSqft]: this.listing.finishedSqft || this.listing.lotSizeSqft,
      };
    },
    marketingQuery() {
      return {
        [QueryParams.Province]: this.listing.province,
        [QueryParams.City]: this.listing.city,
        [QueryParams.Community]: this.listing.community,
        [QueryParams.TransactionDate]: '1 year',
      };
    },
    marketDataQueries() {
      const { buildingClass } = this.listing;

      return {
        ...this.commonComparableQueries,
        ...this.marketingQuery,
        [QueryParams.BuildingClass]: buildingClass,
      };
    },
    listingComparablePageQueries() {
      const { buildingType, buildingClass } = this.listing;

      return {
        ...this.commonComparableQueries,
        [QueryParams.Address]: this.listing.address,
        [QueryParams.BuildingType]: BuildingTypeMapper.mapListingToFilter(
          buildingType,
          buildingClass,
        ),
      };
    },
    comparableLink() {
      return `${routes.comparables}?${QueryParameterHelper.buildQueryString(this.listingComparablePageQueries)}`;
    },
    marketDataLink() {
      return `${routes.marketData}?${QueryParameterHelper.buildQueryString(this.marketDataQueries)}`;
    },
    soldDataLink() {
      return `${routes.soldData}?${QueryParameterHelper.buildQueryString(this.marketingQuery)}`;
    },
    listHomeLink() {
      return routes.listHome;
    },
  },
};

export default NavigationLinksMixin;
